import { sendPost } from "src/utils/sendApi"

export const fetchAuditLogListApi = sendPost("v1/data/_audit_log")

export const fetchAuditLogActionsListApi = sendPost("v1/data/_audit_log_actions")
